import { useEffect, useState } from 'react';
import toBaseLocale from '../utils/toBaseLocale';
import useLocalization from './useLocalization';

var usePageTranslations = function usePageTranslations() {
  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale,
      localeLabels = _useLocalization.localeLabels,
      _useLocalization$tran = _useLocalization.translations,
      translations = _useLocalization$tran === void 0 ? [] : _useLocalization$tran,
      onChangeLocale = _useLocalization.onChangeLocale;

  var _useState = useState(),
      data = _useState[0],
      setData = _useState[1];

  useEffect(function () {
    if (currentLocale) {
      var switcherData = {
        currentLocale: {
          locale: toBaseLocale(currentLocale),
          localeLabel: localeLabels[currentLocale]
        },
        translations: translations.map(function (t) {
          return {
            locale: toBaseLocale(t.locale),
            localeLabel: localeLabels[t.locale],
            url: t.url
          };
        })
      };
      setData(switcherData);
    }
  }, [currentLocale, translations]);
  return [data, {
    onChangeLocale: onChangeLocale
  }];
};

export default usePageTranslations;